import type { FilterSections, ReadonlySearchParams } from '../../types';
import { getFilterFromFilterSections } from '../getFilterFromFilterSections/getFilterFromFilterSections';
import { getFilterFromParams } from '../getFilterFromParams/getFilterFromParams';

export const getInitialFilter = ({
	filterSections,
	searchParams
}: {
	filterSections: FilterSections;
	searchParams: ReadonlySearchParams;
}) => {
	const filterFromFilterSections = getFilterFromFilterSections(filterSections);

	const filterFromParams = getFilterFromParams({
		searchParams,
		filter: filterFromFilterSections
	});

	return filterFromParams;
};
